import AttachmentChip from './AttachmentChip';

export default AttachmentChip;
